<template>
  <div class="account-container">
    <vpd-custom-dialog :dialog="currentCostDialog" title="jelenlegi bankszámla költségeid"
      @close-modal="currentCostDialog = false">
      <vpd-current-cost :selectedBankName="selectedBankName" :showButton="false" :accountInfo="calculationResult"
        @recalculate="modifiyCalculation('current')"></vpd-current-cost>
    </vpd-custom-dialog>
    <vpd-custom-dialog :dialog="baseAccountDialog" title="K&H alapszámla" @close-modal="baseAccountDialog = false">
      <vpd-kh-cost :accountInfo="calculationResult?.resultsByPackage?.ALAP"
        @recalculate="modifiyCalculation('base')"></vpd-kh-cost>
    </vpd-custom-dialog>
    <vpd-custom-dialog :dialog="plusAccountDialog" title="K&H kényelmi plusz" @close-modal="plusAccountDialog = false">
      <vpd-kh-cost :accountInfo="calculationResult?.resultsByPackage?.KENYELMI_PLUSZ"
        @recalculate="modifiyCalculation('plus')"></vpd-kh-cost>
    </vpd-custom-dialog>
    <vpd-custom-dialog :dialog="premiumAccountDialog" title="K&H prémium számla"
      @close-modal="premiumAccountDialog = false">
      <vpd-kh-cost :accountInfo="calculationResult?.resultsByPackage?.PREMIUM"
        @recalculate="modifiyCalculation('premium')"></vpd-kh-cost>
    </vpd-custom-dialog>
    <vpd-custom-dialog :dialog="onlineAccountDialog" title="K&H kényelmi plusz online"
      @close-modal="onlineAccountDialog = false">
      <vpd-kh-cost :accountInfo="calculationResult?.resultsByPackage?.KENYELMI_PLUSZ_ONLINE"
        @recalculate="modifiyCalculation('online')"></vpd-kh-cost>
    </vpd-custom-dialog>
    <vpd-custom-dialog :dialog="onlineOpenAccountDialog" title="online számlanyitás"
      @close-modal="onlineOpenAccountDialog = false">
      <vpd-online-account></vpd-online-account>
    </vpd-custom-dialog>
    <vpd-custom-dialog :dialog="modifyCalculationDialog" :isFullScreen="true" title="kalkuláció módosítása"
      @close-modal="modifyCalculationDialog = false">
      <vpd-modify-calculation :initialForm="selectedForm" :type="selectedType" @startCalculation="startCalculation"
        @close-modal="modifyCalculationDialog = false"></vpd-modify-calculation>
    </vpd-custom-dialog>
    <vpd-account-selector v-model="accountSelectDialog" :accounts="accounts" @selected="onAccountSelected" />
    <vpd-error-dialog v-model="errorDialog" />

    <div v-if="isGeneratingPdf" class="pdf-overlay">
      <div class="pdf-overlay-content">
        PDF készítése…
      </div>
    </div>

    <transition name="kh-overlay-fade">
      <div v-if="showLongTransactionOverlay" class="kh-long-overlay">
        <div class="kh-long-overlay-inner">
          <div class="kh-long-overlay-spinner">
            <svg class="kh-spinner-svg" viewBox="0 0 100 100">
              <!-- light ring -->
              <circle class="kh-spinner-ring" cx="50" cy="50" r="45" />
              <!-- blue arc -->
              <circle class="kh-spinner-segment" cx="50" cy="50" r="45" />
            </svg>
          </div>


          <div class="kh-long-overlay-message">
            {{ longTransactionMessage }}
          </div>
        </div>
      </div>
    </transition>

    <div class="calculation-background"></div>
    <div class="calculation-container">

      <div ref="resultContainer" class="calculation-details-container">
        <div class="calculation-header-container">
          <div class="calculation-header">
            <h1 class="calculator-header-title pdf-color-target" v-if="!isModifiedCalculation">
              kalkulációd eredménye
            </h1>
            <h1 class="calculator-header-title pdf-color-target" v-if="isModifiedCalculation">
              új K&H kalkulációd eredménye
            </h1>
            <div class="text pdf-color-target preline" v-if="!isModifiedCalculation">
              {{ lastTwoFullMonthsHuText(false) }}
            </div>
            <div class="text pdf-color-target" v-if="isModifiedCalculation">
              az általad megadott tranzakciós szokásokkal a várható K&H bankköltséged
            </div>
          </div>

          <div class="logout-button-container pdf-hidden" @click="recalculate()">
            kalkuláció újraindítása
          </div>
        </div>


        <div class="proposal-dialog">
          <div class="current-account-container" v-if="!isModifiedCalculation">
            <img v-if="!isCalculationLoading" :src="getBankMiniImgUrl(selectedBank)" alt="logo" height="48px" />
            <span class="image-skeleton" v-else></span>
            <div class="card-data-container">
              <span class="current-price">jelenlegi banki költségeid</span>
              <div class="card-amount-container">
                <span v-if="!isCalculationLoading" class="base-amount">{{
                  balanceFormatter(calculationResult?.currentAccountCost) }}
                </span>
                <span class="base-amount-skeleton" v-else></span>
                <span class="latest-amount">{{ lastTwoFullMonthsHuText(true) }}</span>
              </div>
              <div v-if="showDetailsButton" class="details-button-container pdf-hidden" @click="showDetails('current')"
                @click.stop="currentCostDialog = true">
                részletek
              </div>
            </div>
          </div>

          <img class="arrow-logo" :src="arrowLogo" alt="Arrow logo" height="40px" v-if="!isModifiedCalculation" />

          <div v-if="!hideOnMobile" class="lg-card-container">
            <div class="best-choice-container pdf-hidden">
              legjobb választás
            </div>
            <div class="lg-card-header">
              <img :src="khLogo" alt="Kh logo" height="52px" />
              <div class="card-data-container">
                <span v-if="packages.length > 0" class="base-account">{{ packages[0]?.title }}</span>
                <span v-else class="base-account-skeleton"></span>
                <div class="card-amount-container">
                  <span v-if="!isCalculationLoading" class="base-amount">{{
                    balanceFormatter(packages[0]?.totalCost) }}</span>
                  <span class="base-amount-skeleton" v-else></span>
                  <span class="latest-amount">
                    <div class="months-text-container">
                      <span class="line1">az elmúlt 2 teljes hónap összege</span>
                      <span>{{ lastTwoMonthsHu() }}</span>
                    </div>
                  </span>
                </div>
              </div>
            </div>

            <div class="lg-card-details">
              <div class="lg-card-row">
                <img :src="checkLogo" alt="Ok logo" height="24px" />
                <div v-if="packages.length > 0">{{ packages[0]?.text1 }}
                </div>
                <div v-else class="lg-card-row-skeleton"></div>
              </div>
              <div class="lg-card-row">
                <img :src="checkLogo" alt="Ok logo" height="24px" />
                <div v-if="packages.length > 0">{{ packages[0]?.text2 }}</div>
                <div v-else class="lg-card-row-skeleton"></div>
              </div>
              <div class="lg-card-row">
                <img :src="checkLogo" alt="Ok logo" height="24px" />
                <div v-if="packages.length > 0">{{ packages[0]?.text3 }}</div>
                <div v-else class="lg-card-row-skeleton"></div>
              </div>
            </div>

            <div class="lg-card-button-container pdf-hidden">
              <div class="details-button-container" @click="showDetails(packages[0]?.type)">
                részletek
              </div>
              <template v-if="packages[0]?.actionButton === 'időpontot foglalok'">
                <div class="appointment-button-container" @click="getAppointment">
                  időpontot foglalok
                </div>
              </template>
              <template v-else>
                <div class="lg-appointment-button-container" @click="onlineAccountClick()">
                  online számlanyitás
                </div>
              </template>
            </div>
          </div>
        </div>

        <div class="h2-container pdf-hidden">
          <h2>kiemelt számlacsomagok</h2>
        </div>

        <div class="sm-card-containers">
          <div v-if="hideOnMobile" class="sm-card-container">
            <div class="sm-card-data-container">
              <div class="best-choice-container pdf-hidden">
                legjobb választás
              </div>
              <div class="sm-card-header">
                <img :src="khLogo" alt="Kh logo" height="52px" />
                <div class="card-data-container">
                  <span v-if="packages.length > 0" class="base-account">{{ packages[0]?.title }}</span>
                  <span v-else class="base-account-skeleton"></span>
                  <div class="card-amount-container">
                    <span v-if="!isCalculationLoading" class="base-amount">{{
                      balanceFormatter(packages[0]?.totalCost) }}</span>
                    <span class="base-amount-skeleton" v-else></span>
                    <span class="latest-amount">{{ lastTwoFullMonthsHuText(true) }}</span>
                  </div>
                </div>
              </div>

              <div class="sm-card-details">
                <div class="sm-card-row">
                  <img :src="checkLogo" alt="Ok logo" height="24px" />
                  <div v-if="packages.length > 0">{{ packages[0]?.text1 }}
                  </div>
                  <div v-else class="sm-card-row-skeleton"></div>
                </div>
                <div class="sm-card-row">
                  <img :src="checkLogo" alt="Ok logo" height="24px" />
                  <div v-if="packages.length > 0">{{ packages[0]?.text2 }}</div>
                  <div v-else class="sm-card-row-skeleton"></div>
                </div>
                <div class="sm-card-row">
                  <img :src="checkLogo" alt="Ok logo" height="24px" />
                  <div v-if="packages.length > 0">{{ packages[0]?.text3 }}</div>
                  <div v-else class="sm-card-row-skeleton"></div>
                </div>
              </div>
            </div>

            <div class="sm-card-button-container pdf-hidden">
              <div class="details-button-container" @click="showDetails(packages[0]?.type)">
                részletek
              </div>
              <template v-if="packages[0]?.actionButton === 'időpontot foglalok'">
                <div class="lg-appointment-button-container" @click="getAppointment">
                  időpontot foglalok
                </div>
              </template>
              <template v-else>
                <div class="lg-appointment-button-container" @click="onlineAccountClick()">
                  online számlanyitás
                </div>
              </template>
            </div>
          </div>

          <div class="sm-card-container">
            <div class="sm-card-data-container">
              <div class="sm-card-header">
                <img :src="khLogo" alt="Kh logo" height="52px" />
                <div class="card-data-container">
                  <span v-if="packages.length > 0" class="base-account">{{ packages[1]?.title }}</span>
                  <span v-else class="base-account-skeleton"></span>
                  <div class="card-amount-container">
                    <span v-if="!isCalculationLoading" class="base-amount">{{
                      balanceFormatter(packages[1]?.totalCost) }}</span>
                    <span class="base-amount-skeleton" v-else></span>
                    <span class="latest-amount">{{ lastTwoFullMonthsHuText(true) }}</span>
                  </div>
                </div>
              </div>

              <div class="sm-card-details">
                <div class="sm-card-row">
                  <img :src="checkLogo" alt="Ok logo" height="24px" />
                  <div v-if="packages.length > 0">{{ packages[1]?.text1 }}
                  </div>
                  <div v-else class="sm-card-row-skeleton"></div>
                </div>
                <div class="sm-card-row">
                  <img :src="checkLogo" alt="Ok logo" height="24px" />
                  <div v-if="packages.length > 0">{{ packages[1]?.text2 }}</div>
                  <div v-else class="sm-card-row-skeleton"></div>
                </div>
                <div class="sm-card-row">
                  <img :src="checkLogo" alt="Ok logo" height="24px" />
                  <div v-if="packages.length > 0">{{ packages[1]?.text3 }}</div>
                  <div v-else class="sm-card-row-skeleton"></div>
                </div>
              </div>
            </div>

            <div class="sm-card-button-container pdf-hidden">
              <div class="details-button-container" @click="showDetails(packages[1]?.type)">
                részletek
              </div>
              <template v-if="packages[1]?.actionButton === 'időpontot foglalok'">
                <div class="lg-appointment-button-container" @click="getAppointment">
                  időpontot foglalok
                </div>
              </template>
              <template v-else>
                <div class="lg-appointment-button-container" @click="onlineAccountClick()">
                  online számlanyitás
                </div>
              </template>
            </div>
          </div>

          <div class="sm-card-container">
            <div class="sm-card-data-container">
              <div class="sm-card-header">
                <img :src="khLogo" alt="Kh logo" height="52px" />
                <div class="card-data-container">
                  <span v-if="packages.length > 0" class="base-account">{{ packages[2]?.title }}</span>
                  <span v-else class="base-account-skeleton"></span>
                  <div class="card-amount-container">
                    <span v-if="!isCalculationLoading" class="base-amount">{{
                      balanceFormatter(packages[2]?.totalCost) }}</span>
                    <span class="base-amount-skeleton" v-else></span>
                    <span class="latest-amount">{{ lastTwoFullMonthsHuText(true) }}</span>
                  </div>
                </div>
              </div>

              <div class="sm-card-details">
                <div class="sm-card-row">
                  <img :src="checkLogo" alt="Ok logo" height="24px" />
                  <div v-if="packages.length > 0">{{ packages[2]?.text1 }}
                  </div>
                  <div v-else class="sm-card-row-skeleton"></div>
                </div>
                <div class="sm-card-row">
                  <img :src="checkLogo" alt="Ok logo" height="24px" />
                  <div v-if="packages.length > 0">{{ packages[2]?.text2 }}</div>
                  <div v-else class="sm-card-row-skeleton"></div>
                </div>
                <div class="sm-card-row">
                  <img :src="checkLogo" alt="Ok logo" height="24px" />
                  <div v-if="packages.length > 0">{{ packages[2]?.text3 }}</div>
                  <div v-else class="sm-card-row-skeleton"></div>
                </div>
              </div>
            </div>

            <div class="sm-card-button-container pdf-hidden">
              <div class="details-button-container" @click="showDetails(packages[2]?.type)">
                részletek
              </div>
              <template v-if="packages[2]?.actionButton === 'időpontot foglalok'">
                <div class="appointment-button-container" @click="getAppointment">
                  időpontot foglalok
                </div>
              </template>
              <template v-else>
                <div class="lg-appointment-button-container" @click="onlineAccountClick()">
                  online számlanyitás
                </div>
              </template>
            </div>
          </div>

          <div class="sm-card-container">
            <div class="sm-card-data-container">
              <div class="sm-card-header">
                <img :src="khLogo" alt="Kh logo" height="52px" />
                <div class="card-data-container">
                  <span v-if="packages.length > 0" class="base-account">{{ packages[3]?.title }}</span>
                  <span v-else class="base-account-skeleton"></span>
                  <div class="card-amount-container">
                    <span v-if="!isCalculationLoading" class="base-amount">{{
                      balanceFormatter(packages[3]?.totalCost) }}</span>
                    <span class="base-amount-skeleton" v-else></span>
                    <span class="latest-amount">{{ lastTwoFullMonthsHuText(true) }}</span>
                  </div>
                </div>
              </div>

              <div class="sm-card-details">
                <div class="sm-card-row">
                  <img :src="checkLogo" alt="Ok logo" height="24px" />
                  <div v-if="packages.length > 0">{{ packages[3]?.text1 }}
                  </div>
                  <div v-else class="sm-card-row-skeleton"></div>
                </div>
                <div class="sm-card-row">
                  <img :src="checkLogo" alt="Ok logo" height="24px" />
                  <div v-if="packages.length > 0">{{ packages[3]?.text2 }}</div>
                  <div v-else class="sm-card-row-skeleton"></div>
                </div>
                <div class="sm-card-row">
                  <img :src="checkLogo" alt="Ok logo" height="24px" />
                  <div v-if="packages.length > 0">{{ packages[3]?.text3 }}</div>
                  <div v-else class="sm-card-row-skeleton"></div>
                </div>
              </div>
            </div>

            <div class="sm-card-button-container pdf-hidden">
              <div class="details-button-container" @click="showDetails(packages[3]?.type)">
                részletek
              </div>
              <template v-if="packages[3]?.actionButton === 'időpontot foglalok'">
                <div class="appointment-button-container" @click="getAppointment">
                  időpontot foglalok
                </div>
              </template>
              <template v-else>
                <div class="lg-appointment-button-container" @click="onlineAccountClick()">
                  online számlanyitás
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="download-button" @click="savePdf">
        kalkuláció mentése
      </div>

      <div class="account-page-info-container">
        <img :src="infoLogo" alt="Info" height="24px" />
        <span>A kalkulátor az ügyfél jelenlegi számlavezető bankja részére a kalkulációt megelőző 2 hónapban teljesített
          díj-
          és költségterheléseit alapul véve kalkulál, azonban a bankszámlaválasztás során egyéb szempontok (pl.: plusz
          szolgáltatások, kedvezmények, stb.) figyelembevétele is javasolt. A kalkulátor a kalkuláció során
          feltételezéseket
          alkalmaz, így a kalkuláció eredménye tájékoztató jellegű, nem minősül ajánlattételnek, az a valós díj-és
          költség
          terhektől eltérhet, így pusztán a figyelem felkeltését szolgálja. A bankszámla, kapcsolódó szolgáltatások
          feltételeit és kondícióit az adott bank hirdetménye tartalmazza. Ha nem teljesülnek a kalkuláció során
          megadott
          feltételek, a Bank nem, vagy nem fenti kondíciókkal fog számodra bankszámlát kínálni. A kalkulátor nem a
          piacon
          elérhető összes bankszámlát elemzi, csupán az ügyfél jelenlegi bankszámláját és a K&H Bank által kínált
          bankszámlákat, így lehetséges, hogy a piacon ezen bankszámláknál kedvezőbb költségű vagy ár/érték ajánlatú
          bankszámlák is vannak.
        </span>
      </div>
      <a class="banner-link"
        href="https://www.kh.hu/napi-penzugyek/szamla?utm_source=bankszamlakalkulator&utm_medium=banner&utm_campaign=folyoszamla-tactical-owned&utm_content=internal-activity">
        <div class="banner-container">
          <div class="text-container">
            <div class="banner-text">
              online számlanyitás otthonról, kényelmesen
            </div>
            <div class="mini-button">
              érdekel
            </div>
          </div>
          <img class="banner-image"
            :src="showMdBannerImage ? bannerPictureMd : showSmBannerImage ? bannerPictureSm : bannerPicture"
            alt="Banner picture">
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import "./_Accounts.scss";
import arrowLogo from "@/assets/arrow.svg";
import checkLogo from "@/assets/check.svg";
import khLogo from "@/assets/kh-logo.svg";
import otpLogo from "@/assets/otp-bank.svg";
import infoLogo from "@/assets/info-circle.svg";
import bannerPicture from "@/assets/banner-picture.jpg";
import bannerPictureMd from "@/assets/banner-picture-md.jpg";
import bannerPictureSm from "@/assets/banner-picture-sm.jpg";
import vpdCurrentCost from "../components/vpd-current-cost/vpd-current-cost.vue";
import vpdKhCost from "../components/vpd-kh-cost/vpd-kh-cost.vue";
import vpdOnlineAccount from "../components/vpd-online-account/vpd-online-account.vue";
import vpdCustomDialog from "../components/vpd-custom-dialog/vpd-custom-dialog.vue";
import vpdModifyCalculation from "../components/vpd-modify-calculation/vpd-modify-calculation.vue";
import vpdAccountSelector from "../components/vpd-account-selector/vpd-account-selector.vue";
import vpdErrorDialog from "../components/vpd-error-dialog/vpd-error-dialog.vue";
import Calculation from "./Calculation.vue";
import accountsService from "@/services/accounts-service";
import transactionsService from "@/services/transactions-service";
import khCalculatorService from "@/services/kh-calculator-service";
import screenShotService from "@/services/screenshot-service";
import { getBankMiniImgUrl } from "@/modules/helpers";

export default {
  data() {
    return {
      currentCostDialog: false,
      baseAccountDialog: false,
      plusAccountDialog: false,
      premiumAccountDialog: false,
      onlineOpenAccountDialog: false,
      onlineAccountDialog: false,
      modifyCalculationDialog: false,
      isModifiedCalculation: false,
      isCalculationLoading: false,
      forceDesktopForPdf: false,
      isGeneratingPdf: false,
      accountLogo: null,
      arrowLogo,
      checkLogo,
      khLogo,
      otpLogo,
      infoLogo,
      bannerPicture,
      bannerPictureMd,
      bannerPictureSm,
      selectedBank: null,
      selectedBankName: "",
      accounts: [],
      packages: [],
      accountId: null,
      calculationResult: null,
      ALAP: {
        title: "K&H alapszámla",
        text1: "azoknak szól akiknek csak alapvető pénzügyi szolgáltatásokra van szükségük, kedvező díj mellett",
        text2: "nyisd meg otthonról, töltsd le a K&H számalanyitás app-ot",
        text3: "KATE, a Te digitális asszisztensed a nap 24 órájában elérhető a K&H mobilbankban",
        actionButton: "időpontot foglalok",
        monthlyFee: 0,
        smsCost: 0,
        totalCommission: 0,
        totalLevy: 0,
        totalCost: 0,
        accountFee: 0,
        cardFee: 0,
        transferFees: 0,
        recurringTransferFee: 0,
        groupDirectDebitFee: 0,
        cashWithdrawalFee: 0,
        otherFees: 0,
        currentAccountCost: 0,
        breakdown: [],
        type: 'base'
      },
      KENYELMI_PLUSZ: {
        title: "K&H kényelmi plusz",
        text1: "ha közepes számlaforgalmat bonyolítasz havonta",
        text2: "napi pénzügyeid kényelmesen, online szereted intézni",
        text3: "KATE, a Te digitális asszisztensed a nap 24 órájában elérhető a K&H mobilbankban",
        actionButton: "időpontot foglalok",
        monthlyFee: 0,
        smsCost: 0,
        totalCommission: 0,
        totalLevy: 0,
        totalCost: 0,
        accountFee: 0,
        cardFee: 0,
        transferFees: 0,
        recurringTransferFee: 0,
        groupDirectDebitFee: 0,
        cashWithdrawalFee: 0,
        otherFees: 0,
        currentAccountCost: 0,
        breakdown: [],
        type: 'plus'
      },
      KENYELMI_PLUSZ_ONLINE: {
        title: "K&H kényelmi plusz online",
        text1: "nyiss számlát dec. 19-ig és szerezz akár 60 000 Ft jóváírást",
        text2: "egyszerű bankváltás, online számlanyitás - pár perc alatt, otthonról",
        text3: "visszapénz vásárlások után + KATE, a digitális asszisztensed 0-24-ben",
        actionButton: "online számlanyitás",
        monthlyFee: 0,
        smsCost: 0,
        totalCommission: 0,
        totalLevy: 0,
        totalCost: 0,
        accountFee: 0,
        cardFee: 0,
        transferFees: 0,
        recurringTransferFee: 0,
        groupDirectDebitFee: 0,
        cashWithdrawalFee: 0,
        otherFees: 0,
        currentAccountCost: 0,
        breakdown: [],
        type: 'online'
      },
      PREMIUM: {
        title: "K&H prémium számla",
        text1: "kiemelt figyelmet, elsőbbségi kiszolgálást kapsz",
        text2: "személyre szabott megoldásokat adunk, egyedülálló kedvezmények",
        text3: "prémium családi szolgáltatási lehetőség",
        actionButton: "időpontot foglalok",
        monthlyFee: 0,
        smsCost: 0,
        totalCommission: 0,
        totalLevy: 0,
        totalCost: 0,
        accountFee: 0,
        cardFee: 0,
        transferFees: 0,
        recurringTransferFee: 0,
        groupDirectDebitFee: 0,
        cashWithdrawalFee: 0,
        otherFees: 0,
        currentAccountCost: 0,
        breakdown: [],
        type: 'premium'
      },
      initialForm: {
        electronicTransfer: {
          occasional: { count: null, amount: null },
          regular: { count: null, amount: null },
          groupDirectDebit: { count: null, amount: null },
        },
        paperTransfer: {
          occasional: { count: null, amount: null },
          regular: { count: null, amount: null },
          directDebit: { count: null, amount: null },
        },
        telebankTransfer: {
          occasional: { count: null, amount: null },
          regular: { count: null, amount: null },
          directDebit: { count: null, amount: null },
        },
        cashWithdrawal: {
          ownAtm: { count: null, amount: null },
          otherAtm: { count: null, amount: null },
          ownBranch: { count: null, amount: null },
        },
      },
      selectedForm: null,
      selectedType: "",
      showLongTransactionOverlay: false,
      longTransactionStep: 0,
      longTransactionTimers: [],
      accountSelectDialog: false,
      _accountSelectResolver: null,
      showDetailsButton: true,
      errorDialog: false,
    };
  },
  name: "home",
  components: {
    vpdCurrentCost, vpdKhCost, vpdOnlineAccount, vpdCustomDialog, Calculation,
    vpdModifyCalculation, vpdAccountSelector, vpdErrorDialog
  },
  props: ["config"],
  methods: {
    recalculate() {
      this.$router.push({ name: "logout" }).catch(() => { });
    },
    _sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    async waitForAccounts({ maxWaitMs = 120000 } = {}) {
      const startedAt = Date.now();

      const overlayTimeout = setTimeout(() => {
        this.startLongTransactionOverlay();
      }, 3000);

      try {
        let delay = 800;

        while (Date.now() - startedAt < maxWaitMs) {
          try {
            await this.refreshAccounts({ keepSelection: true });
          } catch (err) {
            console.warn("⚠️ refreshAccounts failed, retrying…", err);
          }

          if (this.accounts && this.accounts.length > 0) {
            return true;
          }

          await this._sleep(delay);
          delay = Math.min(5000, Math.round(delay * 1.4));
        }

        console.log("❌ Accounts polling timed out after 2 minutes.");
        this.errorDialog = true;
        return false;
      } finally {
        clearTimeout(overlayTimeout);
        this.stopLongTransactionOverlay();
      }
    },

    applySelectedAccount(acc) {
      this.accountId = acc?.id ?? null;
      this.selectedBank = acc?.bank ?? null;

      if (this.selectedBank && this.selectedBank === 'erste') {
        this.showDetailsButton = false;
      }

      const aspspProvider = this.config.aspspProviders.filter(p => p.id === this.selectedBank);
      this.selectedBankName = aspspProvider?.length ? aspspProvider[0].description : "";

      this.$store.commit("setAccountsCount", this.accounts?.length ?? 0);
    },

    // Open modal and wait until user clicks one
    async ensureAccountSelected() {
      // if already selected and still exists, keep it
      if (this.accountId && this.accounts.some(a => a.id === this.accountId)) return;

      if (this.accounts.length === 1) {
        this.applySelectedAccount(this.accounts[0]);
        return;
      }

      if (this.accounts.length > 1) {
        this.accountSelectDialog = true;

        await new Promise((resolve) => {
          this._accountSelectResolver = resolve;
        });

        this._accountSelectResolver = null;
      }
    },

    onAccountSelected(acc) {
      this.applySelectedAccount(acc);
      if (this._accountSelectResolver) this._accountSelectResolver();
    },

    startLongTransactionOverlay() {
      if (this.showLongTransactionOverlay) return;

      this.showLongTransactionOverlay = true;
      this.longTransactionStep = 1;

      const t1 = setTimeout(() => {
        if (!this.showLongTransactionOverlay) return;
        this.longTransactionStep = 2;
      }, 8000); // +5s after overlay appears

      const t2 = setTimeout(() => {
        if (!this.showLongTransactionOverlay) return;
        this.longTransactionStep = 3;
      }, 20000); // +17s after overlay appears

      this.longTransactionTimers = [t1, t2];
    },

    stopLongTransactionOverlay() {
      this.showLongTransactionOverlay = false;
      this.longTransactionStep = 0;
      this.longTransactionTimers.forEach(id => clearTimeout(id));
      this.longTransactionTimers = [];
    },

    async waitForStableTransactionCount({ maxWaitMs = 120000 } = {}) {
      const startedAt = Date.now();

      let lastTotalCount = null;
      let stableSince = null;
      let seenNonZero = false;

      const overlayTimeout = setTimeout(() => {
        this.startLongTransactionOverlay();
      }, 3000);

      try {
        // Run immediately, then every 7 seconds (same rhythm as before)
        while (Date.now() - startedAt < maxWaitMs) {
          if (!this.accountId) {
            await this.refreshAccounts({ keepSelection: true });
            if (!this.accountId) {
              await this._sleep(7000);
              continue;
            }
          }

          let total = 0;

          try {
            const transactions = await transactionsService.fetchTransactions(0, 20, this.accountId);
            total = transactions?.totalCount ?? 0;
          }
          catch (err) {
            console.warn("⚠️ fetchTransactions failed, retrying…", err);
          }


          // Mark if we ever saw a count > 0
          if (total > 0) seenNonZero = true;

          // First measurement
          if (lastTotalCount === null) {
            lastTotalCount = total;
            stableSince = Date.now();
            await this._sleep(7000);
            continue;
          }

          // Count changed → reset stability timer
          if (total !== lastTotalCount) {
            lastTotalCount = total;
            stableSince = Date.now();
            await this._sleep(7000);
            continue;
          }

          // Count is the same → check if stable for 7 seconds
          const elapsed = Date.now() - stableSince;
          if (elapsed >= 7000 && seenNonZero) {
            return true;
          }

          await this._sleep(7000);
        }

        console.log("❌ Transaction polling timed out after 2 minutes.");
        this.errorDialog = true;
        return false;
      } finally {
        clearTimeout(overlayTimeout);
        this.stopLongTransactionOverlay();
      }
    },

    async startAccountPolling() {
      const accountsReady = await this.waitForAccounts({ maxWaitMs: 120000 });
      if (!accountsReady) {
        if (!this.errorDialog) {
          this.errorDialog = true;
        }
        this.setLoading(false);
        return;
      }

      // If there is exactly one account, select it automatically
      if (this.accounts.length === 1) {
        this.applySelectedAccount(this.accounts[0]);
      } else {
        // If more, show selector dialog and wait for user selection
        await this.ensureAccountSelected();
      }

      if (!this.accountId) {
        console.log("❌ No account selected - aborting.");
        if (!this.errorDialog) {
          this.errorDialog = true;
        }
        this.setLoading(false);
        return;
      }

      // ALWAYS poll transactions (even for 1 account)
      const txReady = await this.waitForStableTransactionCount({ maxWaitMs: 120000 });
      if (!txReady) {
        if (!this.errorDialog) {
          this.errorDialog = true;
        }
        this.setLoading(false);
        return;
      }

      await this.startInitialCalculation();
    },
    async startInitialCalculation() {
      try {
        if (!this.accountId) {
          console.warn("❌ startInitialCalculation() blocked: accountId is null");
          return;
        }
        this.setLoading(true);
        this.calculationResult = await khCalculatorService.calculateCost(this.accountId);
        this.$gtag.event('calculation-finished-loading', {
          event_category: 'page',
          event_label: 'Calculation finished loading'
        });
        this.setPackages(this.calculationResult);
      } catch (err) {
        this.errorDialog = true;
      } finally {
        this.setLoading(false);
      }
    },
    setPackages(calculationResult) {
      const serverPackages = calculationResult.resultsByPackage || {};

      Object.entries(serverPackages).forEach(([pkgKey, pkgData]) => {
        if (!this[pkgKey]) return;

        Object.assign(this[pkgKey], pkgData);
      });

      this.packages = Object.keys(serverPackages)
        .filter(key => !!this[key])
        .map(key => this[key])
        .sort((a, b) => a.totalCost - b.totalCost);
    },
    async recordAccountOpeningLinkClick() {
      try {
        await khCalculatorService.recordKhAccountOpeningLinkClick();
      } catch (error) {
        console.warn("Failed to record K&H account opening link click.", error);
      }
    },
    onlineAccountClick: async function () {
      this.$gtag.event('online-account-open-clicked', {
        event_category: 'button',
        event_label: 'Online account opening'
      });

      await this.recordAccountOpeningLinkClick();

      if (this.$vuetify.breakpoint.width < 450) {
        window.open(
          "https://www.kh.hu/kh-szamlanyitas?utm_source=kh&utm_medium=qr-kod&utm_campaign=folyoszamla-content-longterm-owned-onboarding&utm_content=internal-activity",
          "_blank",
          "noopener,noreferrer"
        )
      } else {
        this.onlineOpenAccountDialog = true
      }
    },
    showDetails: function (type) {
      this.selectedType = type;
      if (type === 'current') {
        this.currentCostDialog = true;

        this.$gtag.event('current-aspsp-details-clicked', {
          event_category: 'button',
          event_label: 'Clicked details current ASPSP'
        });
      }

      if (type === 'base') {
        this.baseAccountDialog = true;

        this.$gtag.event('base-offer-details-clicked', {
          event_category: 'button',
          event_label: 'Clicked details K&H offer base'
        });
      }

      if (type === 'plus') {
        this.plusAccountDialog = true;

        this.$gtag.event('plus-offer-details-clicked', {
          event_category: 'button',
          event_label: 'Clicked details K&H offer plus'
        });
      }

      if (type === 'premium') {
        this.premiumAccountDialog = true;

        this.$gtag.event('premium-offer-details-clicked', {
          event_category: 'button',
          event_label: 'Clicked details K&H offer premium'
        });
      }

      if (type === 'online') {
        this.onlineAccountDialog = true;


        this.$gtag.event('online-offer-details-clicked', {
          event_category: 'button',
          event_label: 'Clicked details K&H offer online'
        });
      }
    },
    modifiyCalculation: function (type) {
      this.currentCostDialog = false;
      this.baseAccountDialog = false;
      this.plusAccountDialog = false;
      this.premiumAccountDialog = false;
      this.onlineOpenAccountDialog = false;
      this.onlineAccountDialog = false;
      this.modifyCalculationDialog = true;
      this.selectedForm = this.initialForm;
      if ((this.calculationResult?.inputOverrides?.electronicTransfer?.occasional?.amount ?? 0) > 0) {
        this.selectedForm.electronicTransfer.occasional.amount =
          this.calculationResult?.inputOverrides?.electronicTransfer?.occasional?.amount ?? 0;
      }

      if ((this.calculationResult?.inputOverrides?.electronicTransfer?.regular?.amount ?? 0) > 0) {
        this.selectedForm.electronicTransfer.regular.amount =
          this.calculationResult?.inputOverrides?.electronicTransfer?.regular?.amount ?? 0;
      }

      if ((this.calculationResult?.inputOverrides?.cashWithdrawal?.ownAtm?.amount ?? 0) > 0) {
        this.selectedForm.cashWithdrawal.ownAtm.amount =
          this.calculationResult?.inputOverrides?.cashWithdrawal?.ownAtm?.amount ?? 0;
      }

      if ((this.calculationResult?.inputOverrides?.electronicTransfer?.occasional?.count ?? 0) > 0) {
        this.selectedForm.electronicTransfer.occasional.count =
          this.calculationResult?.inputOverrides?.electronicTransfer?.occasional?.count ?? 0;
      }

      if ((this.calculationResult?.inputOverrides?.electronicTransfer?.regular?.count ?? 0) > 0) {
        this.selectedForm.electronicTransfer.regular.count =
          this.calculationResult?.inputOverrides?.electronicTransfer?.regular?.count ?? 0;
      }

      if (this.calculationResult?.inputOverrides?.cashWithdrawal?.ownAtm?.count ?? 0 > 0) {
        this.selectedForm.cashWithdrawal.ownAtm.count =
          this.calculationResult?.inputOverrides?.cashWithdrawal?.ownAtm?.count ?? 0;
      }


      if (type === 'current') {
        this.$gtag.event('modify-calculation-current-aspsp-clicked', {
          event_category: 'button',
          event_label: 'Modify calculation details current aspsp'
        });
      }

      if (type === 'base') {
        this.$gtag.event('modify-calculation-base-offer-clicked', {
          event_category: 'button',
          event_label: 'Modify calculation details K&H offer base'
        });
      }
      if (type === 'plus') {
        this.$gtag.event('modify-calculation-plus-offer-clicked', {
          event_category: 'button',
          event_label: 'Modify calculation details K&H offer plus'
        });
      }
      if (type === 'premium') {
        this.$gtag.event('modify-calculation-premium-offer-clicked', {
          event_category: 'button',
          event_label: 'Modify calculation details K&H offer premium'
        });
      }
      if (type === 'online') {
        this.$gtag.event('modify-calculation-online-offer-clicked', {
          event_category: 'button',
          event_label: 'Modify calculation details K&H offer online'
        });

      }
    },
    startCalculation: async function (form, type) {
      if (type === 'current') {
        this.$gtag.event('calculation-modified-current-aspsp-clicked', {
          event_category: 'button',
          event_label: 'Calculation modified current aspsp'
        });
      }

      if (type === 'base') {
        this.$gtag.event('calculation-modified-base-offer-clicked', {
          event_category: 'button',
          event_label: 'Calculation modified K&H offer base'
        });
      }

      if (type === 'plus') {
        this.$gtag.event('calculation-modified-plus-offer-clicked', {
          event_category: 'button',
          event_label: 'Calculation modified K&H offer plus'
        });
      }

      if (type === 'premium') {
        this.$gtag.event('calculation-modified-premium-offer-clicked', {
          event_category: 'button',
          event_label: 'Calculation modified K&H offer premium'
        });
      }

      if (type === 'online') {
        this.$gtag.event('calculation-modified-online-offer-clicked', {
          event_category: 'button',
          event_label: 'Calculation modified K&H offer online'
        });
      }

      this.modifyCalculationDialog = false;
      if (!this.accountId) {
        return;
      }
      try {
        this.setLoading(true);
        this.isModifiedCalculation = true;
        this.calculationResult = await khCalculatorService.calculateCost(this.accountId, form);
        this.setPackages(this.calculationResult);
      } finally {
        this.setLoading(false);
      }
    },
    setLoading: function (value) {
      this.isCalculationLoading = value;
    },
    loadAccountsData(data, { keepSelection = true } = {}) {
      this.accounts = (data.items || []).filter(
        account => account.isValid.toLowerCase() === "true" || account.deletedAt
      );

      if (keepSelection && this.accountId && this.accounts.some(a => a.id === this.accountId)) {
        const selected = this.accounts.find(a => a.id === this.accountId);
        this.applySelectedAccount(selected);
        return;
      }

      if (this.accounts.length === 1) {
        this.applySelectedAccount(this.accounts[0]);
        return;
      }

      this.$store.commit("setAccountsCount", this.accounts.length);
    },
    async getAppointment() {
      this.$gtag.event('branch-visit-appointment-clicked', {
        event_category: 'button',
        event_label: 'Branch visit appointment'
      });

      await this.recordAccountOpeningLinkClick();

      window.open(
        "https://idopontfoglalas.kh.hu/Customer/BranchLocator?scm=valaszto&sc=1522b23e-adee-484e-a855-3fb4a640882c&utm_source=bankszamla-kalkulator&utm_medium=link&utm_campaign=folyoszamla&utm_content=internal-activity",
        "_blank",
        "noopener,noreferrer"
      )
    },
    getBankMiniImgUrl(bank) {
      if (!bank) return;
      return getBankMiniImgUrl(bank);
    },
    async refreshAccounts({ keepSelection = true } = {}) {
      const accountsData = await accountsService.fetchAccounts();
      if (!accountsData) return;
      this.loadAccountsData(accountsData, { keepSelection });
    },
    async savePdf() {
      this.$gtag.event('download-calculation-clicked', {
        event_category: 'button',
        event_label: 'Downloaded calculation in PDF'
      });

      const wasForced = this.forceDesktopForPdf;
      this.forceDesktopForPdf = true;
      const minDuration = 1000;
      const start = Date.now();

      this.isGeneratingPdf = this.isReallyMobile;
      await this.$nextTick();

      try {
        await screenShotService.saveAsPdf(this.$refs.resultContainer, 'kalkulacio.pdf', {
          orientation: 'p',
          excludeSelectors: ['.pdf-hidden'],
        });
      } finally {
        this.forceDesktopForPdf = wasForced;
        await this.$nextTick();
        const elapsed = Date.now() - start;
        const remaining = minDuration - elapsed;
        if (remaining > 0) {
          await new Promise(resolve => setTimeout(resolve, remaining));
        }

        this.isGeneratingPdf = false;
      }
    },
    lastTwoFullMonthsHuText(isShortText, date = new Date()) {
      const monthsHu = [
        "január", "február", "március", "április", "május", "június",
        "július", "augusztus", "szeptember", "október", "november", "december"
      ];

      const currentMonthIndex = date.getMonth(); // 0..11
      const lastFull = (currentMonthIndex - 1 + 12) % 12;
      const secondLastFull = (currentMonthIndex - 2 + 12) % 12;

      return isShortText ? `az elmúlt 2 teljes hónap összege\n(${monthsHu[secondLastFull]} és ${monthsHu[lastFull]})`
        : `az elmúlt 2 teljes havi ${monthsHu[secondLastFull]}i és ${monthsHu[lastFull]}i\n számla használatod alapján`;
    },
    lastTwoMonthsHu(date = new Date()) {
      const monthsHu = [
        "január", "február", "március", "április", "május", "június",
        "július", "augusztus", "szeptember", "október", "november", "december"
      ];

      const currentMonthIndex = date.getMonth(); // 0..11
      const lastFull = (currentMonthIndex - 1 + 12) % 12;
      const secondLastFull = (currentMonthIndex - 2 + 12) % 12;

      return `(${monthsHu[secondLastFull]} és ${monthsHu[lastFull]})`
    }
  },
  computed: {
    showMdBannerImage() {
      return this.$vuetify.breakpoint.width > 420 && this.$vuetify.breakpoint.width < 768;
    },
    showSmBannerImage() {
      return this.$vuetify.breakpoint.width <= 420;
    },
    isReallyMobile() {
      return this.$vuetify.breakpoint.width < 768;
    },
    hideOnMobile() {
      return this.isReallyMobile && !this.forceDesktopForPdf;
    },
    balanceFormatter() {
      return (amount, currency = 'HUF') =>
        new Intl.NumberFormat('hu-HU', { style: 'currency', currency, maximumFractionDigits: 0 })
          .format(Number(amount))
    },
    longTransactionMessage() {
      switch (this.longTransactionStep) {
        case 1:
          return "A folyamat hosszabb lehet a szokásosnál - kérjük, ne zárd be az ablakot.";
        case 2:
          return "Adatok lekérése folyamatban…";
        case 3:
          return "Ez a lépés akár 1 percet is igénybe vehet. Köszönjük a türelmed!";
        default:
          return "";
      }
    },
  },
  async created() {
    this.setLoading(true);
    await this.startAccountPolling();
  },
  beforeDestroy() {
    if (this.pollInterval) clearInterval(this.pollInterval);
  },
  mounted() {
    this.$gtag.event('returned-to-calculation_page', {
      event_category: 'page',
      event_label: 'Returned to Calculator result'
    });
  },
}
</script>
